import React from 'react'

const FormCard = ({children}) => {
  return (
    <div className=' p-6 bg-white border border-gray-200 rounded-lg shadow-md w-[65%] flex gap-10 flex-col'>
       {
        children
       }
    </div>
  )
}

export default FormCard